import React, { forwardRef } from 'react';
import styled from 'styled-components';

interface EventIncomingProps {
  size?: string;
}

const SVG = styled.svg`
  overflow: visible;
`;

export const EventIncoming = forwardRef<SVGSVGElement, EventIncomingProps>((props, ref) => {
  const size = props.size ?? '16px';

  return (
    <SVG
      {...props}
      ref={ref}
      height={size}
      width={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 4.5L11.5 11.5M11.5 11.5V5.9M11.5 11.5H5.9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </SVG>
  );
});
